module.exports = __webpack_public_path__ + "img/download-icon.a2a2eeed.svg";